export const DATE_FORMAT = "MMMd";
export const DISTANCE = "DISTANCE";
export const EG_RECS_STRATEGY = "EG_RECS";
